export default {
    toDoNameList:[
        {
            entityField: "businessId",
            showField: "单据编号",
            fieldType:'toDetail',
            fieldWeight: 110,
            isSort:true,
        },
        {
            entityField: "businessType",
            showField: "待办事项",
            fieldType:'string',
            fieldWeight: 120,
           isSort:true,
        },
        {
            entityField: "remark",
            showField: "备注",
            fieldType:'string',
            fieldWeight: 200,
           isSort:true,
        },
        {
            entityField: "creater",
            showField: "发起人",
            fieldType:'string',
            fieldWeight: 90,
           isSort:true,
        },
      
        {
            entityField: "createTime",
            showField: "发起时间",
            fieldType:'date',
            fieldWeight: 120,
           isSort:true,
        },
    ],
    toAuditNameList:[
        {
            entityField: "businessId",
            showField: "单据编号",
            fieldType:'toDetail',
            fieldWeight: 110,
            isSort:true,
        },
        {
            entityField: "taskName",
            showField: "任务名称",
            fieldType:'string',
            fieldWeight: 140,
           isSort:true,
        },
        {
            entityField: "taskContent",
            showField: "摘要",
            fieldType:'string',
            fieldWeight: 320,
           isSort:true,
        },
        {
            entityField: "createrName",
            showField: "发起人",
            fieldType:'string',
            fieldWeight: 90,
           isSort:true,
        },
      
        {
            entityField: "createTime",
            showField: "发起时间",
            fieldType:'date',
            fieldWeight: 150,
           isSort:true,
        },
    ],
    toSeeNameList:[
        {
            entityField: "businessId",
            showField: "单据编号",
            fieldType:'toDetail',
            fieldWeight: 110,
            isSort:true,
        },
        {
            entityField: "appName",
            showField: "业务类型",
            fieldType:'string',
            fieldWeight: 130,
           isSort:true,
        },
        {
            entityField: "taskContent",
            showField: "摘要",
            fieldType:'string',
            fieldWeight: 320,
           isSort:true,
        },
        {
            entityField: "nodeName",
            showField: "下个节点",
            fieldType:'string',
            fieldWeight: 120,
           isSort:true,
        },
        {
            entityField: "taskReviewer",
            showField: "下节点审批人",
            fieldType:'string',
            fieldWeight: 140,
           isSort:true,
        },
        {
            entityField: "createTime",
            showField: "创建时间",
            fieldType:'date',
            fieldWeight: 150,
           isSort:true,
        },
    ],
    doneNameList:[
        {
            entityField: "businessId",
            showField: "单据编号",
            fieldType:'toDetail',
            fieldWeight: 110,
            isSort:true,
        },
        {
            entityField: "taskName",
            showField: "任务名称",
            fieldType:'string',
            fieldWeight: 140,
           isSort:true,
        },
        {
            entityField: "taskContent",
            showField: "摘要",
            fieldType:'string',
            fieldWeight: 320,
           isSort:true,
        },
        {
            entityField: "createrName",
            showField: "发起人",
            fieldType:'',
            fieldWeight: 150,
           isSort:true,
        },
        {
            entityField: "createTime",
            showField: "发起时间",
            fieldType:'date',
            fieldWeight: 150,
           isSort:true,
        },
    ],
}